module.exports = __webpack_public_path__ + "static/img/standard-3.05dedded.png";